import React from 'react';
import i18n from '../../i18n';
import Button from "@material-ui/core/Button/Button";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import CardActions from "@material-ui/core/CardActions/CardActions";
import {withStyles} from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip/Chip";
import {FormattedDate} from "react-intl";
import Icon from "@material-ui/core/Icon/Icon";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import IconButton from "@material-ui/core/IconButton/IconButton";
import Divider from "@material-ui/core/Divider/Divider";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";

class ContactGrid extends React.Component {
    render() {
        const {contacts, classes} = this.props;

        return (
            <section>
                <Grid container spacing={16}>
                    {contacts.map(contact => {
                        contact.is_craft = contact.contact_type == 'craft';

                        let fullname = contact.is_company ? contact.company_name : contact.first_name + ' ' + contact.last_name

                        return (
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={contact.id}>
                                <Card>
                                    <CardContent className={classes.cardContent}>
                                        <Grid container spacing={8} justify="space-between" alignItems="center">
                                            <Grid item xs={12} sm={contact.is_craft && contact.department ? 7 : 12}>
                                                {/*<a href={`/contacts/${contact.contact_type}/${contact.id}`} style={{textDecoration: 'none'}}>*/}
                                                    <Typography variant="h6" component="h2">
                                                        <EllipisWithTooltip>{fullname}</EllipisWithTooltip>
                                                    </Typography>
                                                {/*</a>*/}
                                            </Grid>
                                            <Grid item xs={12} sm={5}>
                                                <Grid container justify="flex-end">
                                                    <Grid item>
                                                        {contact.is_craft && contact.department && (
                                                            <Chip color="primary" variant="outlined"
                                                                  label={contact.department}
                                                                  classes={{root: classes.chip, label: classes.chipLabel}}/>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {contact.first_name && contact.last_name && (
                                            <Typography variant="subtitle1">
                                                {`${contact.first_name} ${contact.last_name}`}
                                            </Typography>
                                        )}

                                        {contact.street && (
                                            <Typography>
                                                <span>
                                                    {contact.street} {contact.housenumber || ''} <br/>
                                                    {contact.zip || ''} {contact.city || ''}
                                                </span>
                                            </Typography>
                                        )}

                                        {! contact.is_craft && contact.tenant_since && (
                                            <Typography>
                                                <br/>
                                                {i18n.get('contacts.tenant_since')}&nbsp;
                                                <FormattedDate value={new Date(contact.tenant_since)}/>
                                            </Typography>
                                        )}

                                    </CardContent>

                                    <Divider />

                                    <CardActions className={classes.cardActions}>
                                        <Grid container justify="space-between" alignItems="center">
                                            <Grid item>
                                                {contact.email && (
                                                    <Tooltip placement="bottom-start" title={contact.email} classes={{tooltip : classes.popper}}>
                                                        <IconButton href={`mailto:${contact.email}`} className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>alternate_email</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                )}

                                                {contact.telephone && (
                                                    <Tooltip placement="bottom-start" title={contact.telephone} classes={{tooltip : classes.popper}}>
                                                        <IconButton href={`tel:${contact.telephone}`} className={classes.iconButton}>
                                                            <Icon className={classes.iconButtonIcon}>phone</Icon>
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </Grid>

                                            <Grid item>
                                                {/*<Tooltip placement="bottom-end" title={i18n.get('contacts.show_more')} classes={{tooltip : classes.popper}}>*/}
                                                    {/*<IconButton href={`/contacts/${contact.contact_type}/${contact.id}`} className={classes.iconButton}>*/}
                                                        {/*<Icon className={classes.iconButtonIcon}>keyboard_arrow_right</Icon>*/}
                                                    {/*</IconButton>*/}
                                                {/*</Tooltip>*/}

                                                <IconButton href={`/contacts/${contact.contact_type}/${contact.id}/edit`} className={classes.iconButton}>
                                                    <Icon className={classes.iconButtonIcon}>edit</Icon>
                                                </IconButton>
                                            </Grid>
                                        </Grid>
                                    </CardActions>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </section>
        )
    }
}

const styles = theme => ({
    cardContent: {
        minHeight: '150px'
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px'
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1
        }
    },
    iconButtonIcon: {
        fontSize: 20
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)'
    }
});

export default withStyles(styles)(ContactGrid);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Contacts/ContactGrid.js